import { useMemo } from 'react';

export function useFade(active: boolean) {
  return useMemo(() => ({ opacity: active ? 1 : 0 }), [active]);
}
